export var isDev = function () { return process.env.NODE_ENV === 'development'; };
